var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import { ref } from "vue";
import { GalaxyApi } from "@/api";
import {} from "@/api/invocations";
import { useKeyedCache } from "@/composables/keyedCache";
import { rethrowSimple } from "@/utils/simple-error";
export const useInvocationStore = defineStore("invocationStore", () => {
    const graphStepsByStoreId = ref({});
    function fetchInvocationDetails(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield GalaxyApi().GET("/api/invocations/{invocation_id}", {
                params: { path: { invocation_id: params.id } },
            });
            if (error) {
                rethrowSimple(error);
            }
            return data;
        });
    }
    function fetchInvocationJobsSummary(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield GalaxyApi().GET("/api/invocations/{invocation_id}/jobs_summary", {
                params: { path: { invocation_id: params.id } },
            });
            if (error) {
                rethrowSimple(error);
            }
            return data;
        });
    }
    function fetchInvocationStep(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield GalaxyApi().GET("/api/invocations/steps/{step_id}", {
                params: { path: { step_id: params.id } },
            });
            if (error) {
                rethrowSimple(error);
            }
            return data;
        });
    }
    const { getItemById: getInvocationById, fetchItemById: fetchInvocationForId } = useKeyedCache(fetchInvocationDetails);
    const { getItemById: getInvocationJobsSummaryById, fetchItemById: fetchInvocationJobsSummaryForId } = useKeyedCache(fetchInvocationJobsSummary);
    const { getItemById: getInvocationStepById, fetchItemById: fetchInvocationStepById } = useKeyedCache(fetchInvocationStep);
    return {
        getInvocationById,
        fetchInvocationForId,
        getInvocationJobsSummaryById,
        fetchInvocationJobsSummaryForId,
        getInvocationStepById,
        fetchInvocationStepById,
        graphStepsByStoreId,
    };
});
